import Icon from "@mui/icons-material/AccountTreeRounded";

export default function ClassBrowserIcon() {
	return <Icon fontSize="small" />;
}
